import { isArray } from 'lodash';
import React, { useCallback } from 'react';
import { Select, MultiSelect, Tooltip, Icon } from '@grafana/ui';
import { selectors } from '@grafana/e2e-selectors';

var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const LoadingIndicator = (_a) => {
  var _b = _a, props = __objRest(_b, ["innerProps"]);
  const { onCancel } = props.selectProps;
  const onMouseDown = useCallback(
    (event) => {
      event.preventDefault();
      event.stopPropagation();
      onCancel();
    },
    [onCancel]
  );
  return /* @__PURE__ */ React.createElement(Tooltip, {
    content: "Cancel query"
  }, /* @__PURE__ */ React.createElement(Icon, {
    className: "spin-clockwise",
    name: "sync",
    size: "xs",
    "aria-label": selectors.components.LoadingIndicator.icon,
    role: "button",
    onMouseDown
  }));
};
function VariableValueSelect({ model }) {
  const { value, key, loading } = model.useState();
  return /* @__PURE__ */ React.createElement(Select, {
    id: key,
    placeholder: "Select value",
    width: "auto",
    value,
    allowCustomValue: true,
    tabSelectsValue: false,
    isLoading: loading,
    options: model.getOptionsForSelect(),
    onChange: (newValue) => {
      model.changeValueTo(newValue.value, newValue.label);
    },
    onCancel: () => {
      var _a;
      (_a = model.cancel) == null ? void 0 : _a.call(model);
    },
    components: { LoadingIndicator }
  });
}
function VariableValueSelectMulti({ model }) {
  const { value, key, loading } = model.useState();
  const arrayValue = isArray(value) ? value : [value];
  return /* @__PURE__ */ React.createElement(MultiSelect, {
    id: key,
    placeholder: "Select value",
    width: "auto",
    value: arrayValue,
    tabSelectsValue: false,
    allowCustomValue: true,
    isLoading: loading,
    options: model.getOptionsForSelect(),
    closeMenuOnSelect: false,
    isClearable: true,
    onOpenMenu: () => {
    },
    onCancel: () => {
      var _a;
      (_a = model.cancel) == null ? void 0 : _a.call(model);
    },
    components: { LoadingIndicator },
    onChange: (newValue) => {
      model.changeValueTo(
        newValue.map((v) => v.value),
        newValue.map((v) => v.label)
      );
    }
  });
}
function renderSelectForVariable(model) {
  if (model.state.isMulti) {
    return /* @__PURE__ */ React.createElement(VariableValueSelectMulti, {
      model
    });
  } else {
    return /* @__PURE__ */ React.createElement(VariableValueSelect, {
      model
    });
  }
}

export { VariableValueSelect, VariableValueSelectMulti, renderSelectForVariable };
//# sourceMappingURL=VariableValueSelect.js.map
